import "./style.scss";
import { Dispatch, FC, SetStateAction, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { headerNavLinks } from "@/src/constants/header";
import HeaderDeskSubMenuSlider from "../HeaderDeskSubMenu/HeaderDeskSubMenuSlider/HeaderDeskSubMenuSlider";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
import SearchPageSvg from "@/src/svg/SearchPageSvg";

interface HeaderDeskActivePanelProps {
  absolutActiveTab: string | null;
  setAbsolutActiveTab: Dispatch<SetStateAction<string | null>>;
}

const HeaderDeskActivePanel: FC<HeaderDeskActivePanelProps> = ({
  absolutActiveTab,
  setAbsolutActiveTab,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchTerm.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchTerm.trim())}`);
      handleCloseMenu();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleCloseMenu = () => {
    document.body.classList.remove("hidden");
    setAbsolutActiveTab(null);
  };

  return (
    <>
      {/* Search panel */}
      <div className={`header-active-panel ${absolutActiveTab === "search" ? "active" : ""}`}>
        <div className="header-active-panel-search">
          <div className="container">
            <h1 className="header-active-panel-search-title">Search</h1>
            <div className="header-active-panel-search-input">
              <input
                type="search"
                placeholder="Поиск..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button onClick={handleSearch}>
                <SearchPageSvg /> <span>Найти</span>
              </button>
            </div>
          </div>
        </div>
        <div
          className={`modal-blur-space ${absolutActiveTab === "search" ? "visible" : ""}`}
          onClick={handleCloseMenu}
          role="button"
          tabIndex={0}
        ></div>
      </div>

      {/* Menu panel */}
      <div className={`header-active-panel ${absolutActiveTab === "menu" ? "active" : ""}`}>
        <div className="header-menu">
          <div className="container">
            <div className="header-menu-content">
              <p className="header-menu-title">Меню</p>
              <div className="header-menu-cards">
                {headerNavLinks.map((link, index) => (
                  <div className="header-menu-card" key={index}>
                    <div className="header-menu-card-svg">{link.image && <link.image />}</div>
                    <div className="header-menu-card-content">
                      <div className="header-menu-card-title">
                        <p>{link.text}</p>
                      </div>
                      <ul className="header-menu-card-links">
                        {link.submenu &&
                          link.submenu.map((item) => (
                            <li
                              key={item.id}
                              className="header-menu-card-link"
                              onClick={handleCloseMenu}
                            >
                              <Link to={item.link}>{item.text}</Link>
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="sub-menu-content-news">
              <div className="sub-menu-content-news-body">
                <p className="sub-menu-content-news-title">МЫ ПРЕДЛАГАЕМ</p>
                <HeaderDeskSubMenuSlider handleLinkEvent={handleCloseMenu} />
                <ReadMoreBtn
                  text="Подробнее →"
                  link="#"
                  className="sub-menu-content-news-read-more-btn"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal-blur-space ${absolutActiveTab === "menu" ? "visible" : ""}`}
          onClick={handleCloseMenu}
          role="button"
          tabIndex={0}
        ></div>
      </div>
    </>
  );
};

export default HeaderDeskActivePanel;
